export const apiBase = "https://map.goodzonehotel.com.ua/api";
